import { LANGUAGES, } from '@config/languages.config';
/**
 * Utility functions for working with language configuration
 */
/**
 * Get language content by key
 * @param key - Language key
 * @returns Language content or undefined if not found
 */
export const getLanguageContent = (key) => {
    return LANGUAGES[key];
};
/**
 * Get consent text for a language
 * @param key - Language key
 * @returns Consent text or empty string if not found
 */
export const getConsentText = (key) => {
    return LANGUAGES[key]?.consentText ?? '';
};
/**
 * Get reference script for a language
 * @param key - Language key
 * @returns Reference script or empty string if not found
 */
export const getReferenceScript = (key) => {
    return LANGUAGES[key]?.referenceScript ?? '';
};
/**
 * Check if language key is valid
 * @param key - Language key to validate
 * @returns True if valid language key
 */
export const isValidLanguage = (key) => {
    return key in LANGUAGES;
};
